import React, { createContext, useReducer, useContext } from 'react';
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "./constant";


const initialState = {
  loading: true,
  data: null,
  error: null
};


function userReducer(state, action){
  console.log('userReducer ' + state + ' ' + action)
  console.log('state ', state)
  console.log('action ', action)
  switch(action.type){
    case 'GET_USER':
      return {
        ...state,
        loading : true,
      };
    case 'GET_USER_SUCCESS':
      return {
        // ...state,
        data: action.data,
        error: null,
        loading : false,
      };
    case 'GET_USER_ERROR':
      return {
        // ...state,
        data: action.data,
        error: action.error,
        loading : false,
      };
    default:
      throw new Error(`Unhanded action type: ${action.type}`);
  }
}


const UserStateContext = createContext(null);
const UserDispatchContext = createContext(null);



export function UserProvider({ children }) {
  const [state, dispatch] = useReducer(userReducer, initialState);
  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

export function useUserState() {
  const state = useContext(UserStateContext);
  if (!state) {
    throw new Error('Cannot find UserStateContext');
  }
  return state;
}

export function useUserDispatch() {
  const dispatch = useContext(UserDispatchContext);
  if (!dispatch) {
    throw new Error('Cannot find UserDispatchContext');
  }
  return dispatch;
}


export async function getUser(dispatch) {

  dispatch({ type: 'GET_USER' });

  console.log("getUser start => ")
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/user/info`, {
      headers: { 'Content-type': 'application/x-www-form-urlencoded', },
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
      },
    });
    console.log("getUser result => ", response.data)
    if(response.status === 200 && response.data != null && response.data.code === 200){
      dispatch({ type: 'GET_USER_SUCCESS', data: response.data });
    }else{
      dispatch({ type: 'GET_USER_ERROR', error: 'cannot access to server', data: response.data });
    }

  } catch (e) {
    dispatch({ type: 'GET_USER_ERROR', error: e });
  }
}

